import { HIRER_AD_PURCHASER_REPEAT } from 'src/app/shared/constants/tealium';
import { getProductCategories } from 'src/app/utils/analytics/utils/getProductCategories';
import { getProductIds } from 'src/app/utils/analytics/utils/getProductIds';
import { getProductPurchaseId } from 'src/app/utils/analytics/utils/getProductPurchaseId';
import { getProductQuantities } from 'src/app/utils/analytics/utils/getProductQuantities';
import { workArrangmentDescription } from 'src/app/utils/workArrangement/mapper';
import { PRODUCT_EVENTS_PURCHASE } from 'src/app/v1/analytics';
import { getPriceVisibility } from 'src/app/v1/dataAnalytics/utils/getPriceVisibility';
import type { Tealium } from 'src/types/appState';

import { EVENT_VIEW_SUCCESS } from '../constants';

export const eventName = EVENT_VIEW_SUCCESS;

const isRepeatHirer = (hirerType: string) =>
  hirerType === HIRER_AD_PURCHASER_REPEAT;

export default (tealium: Tealium) => {
  const {
    adBudgetPurchased,
    addOnAdProductNames,
    autoClassifyCategoryChosen,
    autoClassifyCategorySuggested,
    cajaHasAIAssistanceBeenUsed,
    cajaPayType,
    cajaWorkType,
    contractProductName,
    contractProductSetProductId,
    discountCode,
    displayPay,
    draftId,
    emailAddressVerified,
    experiments,
    finalJobSummaryCharacterCount,
    hasCoverImage,
    hasLogo,
    hasSufficientBudget,
    hasWorkplaceOption,
    hirerAdPurchaser,
    isLinkOutApplyViaSeek,
    isPaidByStoredCreditCard,
    isPremiumAdOffered,
    isPrivateAd,
    isSaveCreditCardChecked,
    jobAdClassification,
    jobAdPostedWithRR,
    jobAdSubClassification,
    jobAdTypePosted,
    jobAdTypeSelected,
    numberOfBenefits,
    numberOfQualifications,
    numberOfTasks,
    orderNumber,
    paymentMediumSelected,
    paymentMethod,
    priceVisibility,
    productSetId,
    productSetProductIds,
    productTotalPrice,
    recommendedSalaryRange,
    roleTitle,
    rrNumberOfQuestions,
    rrQuestionIds,
    salaryRangeSelected,
    seekListingId,
    cajaWorkplaceOption,
  } = tealium;

  return {
    actionOrigin: 'caja',
    adBenefitCount: numberOfBenefits,
    adProductName: [jobAdTypeSelected],
    addOnAdProductNames,
    adProductSetId: productSetId,
    adQualificationCount: numberOfQualifications,
    adSalaryRangeRecommended: recommendedSalaryRange,
    adSalaryRangeSelected: salaryRangeSelected,
    adTaskCount: numberOfTasks,
    brandHasCoverImage: hasCoverImage,
    brandHasLogo: hasLogo,
    contractProductName,
    contractProductSetProductId,
    discountCode: discountCode || '',
    experiments,
    finalJobSummaryCharacterCount,
    hasAIAssistanceBeenUsed: cajaHasAIAssistanceBeenUsed,
    hasSufficientBudget,
    hasWorkplaceOption,
    isContractPurchaseViewed: Boolean(adBudgetPurchased),
    isEmailUnverified: !emailAddressVerified,
    isHirerRepeatAdPurchaser: isRepeatHirer(hirerAdPurchaser),
    isPaidByStoredCreditCard,
    isPremiumAdOffered,
    isPriceHidden: getPriceVisibility(priceVisibility),
    isPrivateAd,
    isSalaryHidden: !displayPay,
    isSaveCreditCardChecked,
    jobClassification: jobAdClassification,
    jobClassificationSelectedPosition: autoClassifyCategoryChosen,
    jobClassificationSuggestedCount: autoClassifyCategorySuggested,
    jobHasRoleRequirements: jobAdPostedWithRR,
    jobId: seekListingId,
    jobIsLinkOut: Boolean(isLinkOutApplyViaSeek),
    jobListingType: jobAdTypePosted,
    jobSalaryType: cajaPayType,
    jobSubClassification: jobAdSubClassification,
    jobTitle: roleTitle,
    jobWorkType: cajaWorkType,
    paymentMedium: paymentMethod,
    paymentMediumSelected: paymentMediumSelected || '',
    paymentMethod,
    productCategories: getProductCategories(adBudgetPurchased),
    productEvents: [PRODUCT_EVENTS_PURCHASE],
    productIds: getProductIds(
      jobAdTypeSelected,
      jobAdTypePosted,
      adBudgetPurchased,
    ),
    productPurchaseId: getProductPurchaseId(draftId),
    productQuantities: getProductQuantities(adBudgetPurchased),
    productSetProductIds,
    productTotalPrice,
    productTransactionId: getProductPurchaseId(draftId),
    purchasePaymentReferenceNumber: orderNumber || '',
    roleReqQuestionIds: rrQuestionIds,
    roleReqQuestionTotal: rrNumberOfQuestions,
    workplaceOption: workArrangmentDescription(cajaWorkplaceOption),
  };
};
